import EnlilDetail from "../../../../components/EnlilDetail";
import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";

class AdminWorkGroupFormApplet extends Applet {
    state = {
        Name: "AdminUserGroupFormApplet",
        Modes: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "PrimaryEmployeeUSID",
                            },
                            {
                                id: "Status",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "PrimaryEmployeeUSID",
                            },
                            {
                                id: "Status",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "PrimaryEmployeeUSID",
                            },
                            {
                                id: "Status",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            Name: {
                id: "Name",
                enterpriseComponentAttribute: "Name",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Special Characters",
                        value: null,
                        errorText: "Field must not have special characters.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Name",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            PrimaryEmployeeUSID: {
                id: "PrimaryEmployeeUSID",
                enterpriseComponentAttribute: "PrimaryEmployeeUSID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Primary Employee",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Status: {
                id: "Status",
                enterpriseComponentAttribute: "Status",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Status",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            }
        }
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("admin-work-group-form-applet-cancel");
    };

    setMode(mode) {
        super.setMode(mode);

        if (mode === "Save Completed") {
            EventBus.components.emit("admin-work-group-form-applet-save");
        }
    };

    render() {
        return <EnlilDetail applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                modes={this.state.Modes}
                                title="Work Group"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                mode={this.props.defaultMode}
                                errorReportingMethod="RealTime" />;
    }
}

export default AdminWorkGroupFormApplet;
